const CLASS_NAMES = {
    DISPLAY_NAME: '.color-picker__display-name',
    ICON_GROUP: '.icon-group',
    SECONDARY_COLOUR: '.secondary-color',
};

const STATE_CLASSES = {
    COLOR_PICKER_BUTTON_ACTIVE: 'color-picker__button--active',
};

export default class ColorPicker {
    constructor({ colorSwatches, parentElement }) {
        this.self = parentElement;
        this.colorSwatches = colorSwatches;

        this.elements = {
            displayName: parentElement.querySelector(CLASS_NAMES.DISPLAY_NAME),
            iconGroups: parentElement.querySelectorAll(CLASS_NAMES.ICON_GROUP),
            secondaryColors: parentElement.querySelectorAll(CLASS_NAMES.SECONDARY_COLOUR),
        };

        this.init();
    }

    init() {
        this.setupColorSwatches();
    }

    setupColorSwatches() {
        this.colorSwatches.forEach((colorSwatch, index) => {
            this.setupSingleColorSwatch(colorSwatch, index);
        });
    }

    setupSingleColorSwatch(colorSwatch, index) {
        colorSwatch.addEventListener('click', (event) => {
            const colorDisplayValue = colorSwatch.getAttribute('display-value');
            this.removeActiveClass();
            this.addActiveClass(event);
            this.setColorDisplayName(colorDisplayValue);
        });

        this.setSwatchBackgroundColor(this.elements.iconGroups[index]);
        this.setSwatchBackgroundColor(this.elements.secondaryColors[index]);

        if (index === 0) {
            colorSwatch.click();
        }
    }

    setColorDisplayName(name) {
        if (this.elements.displayName) {
            this.elements.displayName.textContent = name;
        }
    }

    removeActiveClass() {
        this.colorSwatches.forEach((elm) => {
            elm.classList.remove(STATE_CLASSES.COLOR_PICKER_BUTTON_ACTIVE);
            elm.setAttribute('aria-current', 'false');
        });
    }

    // eslint-disable-next-line class-methods-use-this
    addActiveClass(event) {
        event.currentTarget.classList.add(STATE_CLASSES.COLOR_PICKER_BUTTON_ACTIVE);
        event.currentTarget.setAttribute('aria-current', 'true');
    }

    // eslint-disable-next-line class-methods-use-this
    setSwatchBackgroundColor(elem) {
        if (!elem) return;

        const hexcode = elem.getAttribute('hexcode');
        if (hexcode) {
            // eslint-disable-next-line no-param-reassign
            elem.style.backgroundColor = hexcode;
        } else {
            // eslint-disable-next-line no-param-reassign
            elem.style.display = 'none';
        }
    }
}
